{
  "hero.title": "Umgebungsumschalter für mehrere CLIs",
  "hero.tagline-1": "in einen Zen-Flow beim Programmieren finden.",
  "hero.tagline-2": "nahtloser Umgebungswechsel.",
  "hero.subtitle": "Einheitliche Verwaltung der Konfigurationen von Claude Code, Codex und OpenCode, mit automatischem Failover des API-Proxys",
  "hero.getDocs": "Dokumentation",
  "features.title": "Funktionen",
  "features.multiCli.title": "Mehrere CLIs",
  "features.multiCli.desc": "Unterstützt Claude Code, Codex und OpenCode, pro Projekt konfigurierbar",
  "features.multiConfig.title": "Konfigurationsverwaltung",
  "features.multiConfig.desc": "Alle API-Provider-Konfigurationen in einer einzigen JSON-Datei",
  "features.daemon.title": "Ein Daemon",
  "features.daemon.desc": "Ein einzelner zend-Prozess betreibt Proxy-Server und Weboberfläche",
  "features.failover.title": "Proxy-Failover",
  "features.failover.desc": "Eingebauter HTTP-Proxy mit automatischem Failover, wenn der primäre Anbieter ausfällt",
  "features.routing.title": "Szenario-Routing",
  "features.routing.desc": "Intelligentes Routing nach Merkmalen der Anfrage (Thinking, Bild usw.)",
  "features.binding.title": "Projektbindungen",
  "features.binding.desc": "Verzeichnisse an bestimmte Profile und CLIs binden, für automatische Konfiguration je Projekt",
  "features.envVars.title": "Umgebungsvariablen",
  "features.envVars.desc": "CLI-spezifische Umgebungsvariablen auf Anbieterebene festlegen",
  "features.webUi.title": "Weboberfläche",
  "features.webUi.desc": "Visuelle Verwaltung im Browser, mit Passwortschutz",
  "features.webSecurity.title": "Web-Sicherheit",
  "features.webSecurity.desc": "Automatisch erzeugtes Passwort, sitzungsbasierte Authentifizierung, RSA-Verschlüsselung für den Token-Transport",
  "features.configSync.title": "Konfigurationssync",
  "features.configSync.desc": "Anbieter, Profile und Einstellungen geräteübergreifend synchronisieren, verschlüsselt mit AES-256-GCM",
  "features.comingSoon": "Weitere Funktionen folgen, bleib dran!",
  "install.title": "Schnellstart",
  "install.step1.title": "GoZen installieren",
  "install.step1.desc": "Installationsskript in einer Zeile",
  "install.step2.title": "Anbieter einrichten",
  "install.step2.desc": "Den ersten API-Anbieter hinzufügen",
  "install.step3.title": "Starten",
  "install.step3.desc": "CLI mit der Standardkonfiguration starten",
  "commands.title": "Befehle",
  "commands.command": "Befehl",
  "commands.description": "Beschreibung",
  "commands.items.start": "CLI starten (über Projektbindung oder Standardkonfiguration)",
  "commands.items.profile": "Mit dem angegebenen Profil starten",
  "commands.items.profilePick": "Profil interaktiv auswählen",
  "commands.items.cli": "Angegebene CLI verwenden (claude/codex/opencode)",
  "commands.items.yes": "CLI-Berechtigungen automatisch bestätigen (claude --permission-mode acceptEdits, codex -a never)",
  "commands.items.use": "Angegebenen Anbieter direkt verwenden (ohne Proxy)",
  "commands.items.pick": "Anbieter interaktiv auswählen",
  "commands.items.list": "Alle Anbieter und Profile auflisten",
  "commands.items.configAddProvider": "Neuen Anbieter hinzufügen",
  "commands.items.configAddProfile": "Neues Profil hinzufügen",
  "commands.items.configDefaultClient": "Standard-CLI-Client festlegen",
  "commands.items.configDefaultProfile": "Standardprofil festlegen",
  "commands.items.configResetPassword": "Passwort der Weboberfläche zurücksetzen",
  "commands.items.configSync": "Konfiguration vom Sync-Backend holen",
  "commands.items.daemonStart": "zend-Daemon starten",
  "commands.items.daemonStop": "Daemon stoppen",
  "commands.items.daemonStatus": "Daemon-Status anzeigen",
  "commands.items.daemonEnable": "Daemon als Systemdienst installieren",
  "commands.items.daemonDisable": "Systemdienst des Daemons entfernen",
  "commands.items.bind": "Aktuelles Verzeichnis an ein Profil binden",
  "commands.items.bindCli": "Aktuelles Verzeichnis an die angegebene CLI binden",
  "commands.items.unbind": "Bindung des aktuellen Verzeichnisses lösen",
  "commands.items.status": "Bindungsstatus des aktuellen Verzeichnisses anzeigen",
  "commands.items.web": "Weboberfläche im Browser öffnen (startet den Daemon)",
  "commands.items.upgrade": "Auf die neueste Version aktualisieren",
  "commands.items.version": "Version anzeigen",
  "commands.items.completion": "Shell-Vervollständigung erzeugen (zsh/bash/fish)",
  "homepage.title": "Umgebungsumschalter für mehrere CLIs"
}
